import { Injectable } from '@angular/core';
import { ApiRoutes } from '../apiroutes';
import { BackendListModel } from '../../models/common/list.model';
import { Observable } from 'rxjs';
import { RoleModel } from 'src/app/models/role-model';
import { HttpClient } from '@angular/common/http';
import { ProfileRole } from 'src/app/models/profile-role';
import { MenuPermission } from 'src/app/models/menu-permission';
@Injectable({
  providedIn: 'root'
})
export class RoleMasterApiService {
  base_url = ApiRoutes.Company;
  base_url1 = ApiRoutes.Core;

  constructor(private http: HttpClient
  ) { }

  // getAllRoles():Observable<BackendListModel<RoleModel>> {
  //   let url = `${this.base_url}role-acl/`;
  //   return this.http.get<BackendListModel<RoleModel>>(url);
  // }
  getAllRoles(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<RoleModel>> {
    let url = `${this.base_url}role-acl/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));
    return this.http.get<BackendListModel<RoleModel>>(String(urlObj));
  }

  //For Creating roles
  postRoleMaster(role: ProfileRole) {
    let url = `${this.base_url}profile_role/`;
    return this.http.post<ProfileRole>(url, role);
  }
  updateRoleMaster(roleId: string, data: ProfileRole) {
    let url = `${this.base_url}profile_role/${roleId}/`;
    return this.http.put<ProfileRole>(url, data);
  }

  postMenuPermission(data: MenuPermission) {
    let url = `${this.base_url1}role_ACL/`;
    return this.http.post<ProfileRole>(url, data);
  }

  updateMenuPermission(menuId: string, data: MenuPermission) {
    let url = `${this.base_url1}role_ACL/${menuId}/`;
    return this.http.put<ProfileRole>(url, data);
  }

}
